import React, { useState } from 'react';
import { object } from 'prop-types';
import { map, get, isEmpty, capitalize } from 'lodash';
import { Timeline, notification } from 'antd';
import moment from 'moment';
import ReactJson from 'react-json-view';
import { FlexContainer, Row, Column, Main, Icon, Button, FormInput, If, NotFound, Loading, Text, Drawer } from '../../common';
import { WHITE, TIGERS_EYE, ANDROID_GREEN, GRANITE_GRAY } from '../../../utils/colors';
import { withFirebase } from '../../../hoc';
import useOrderShopperLogs from './useOrderShopperLogs';
import './shopper-app-logs.css';

const styleNotification = {
    borderRadius: 4,
    height: 55
};

const ShopperAppLogs = ({ firebase }) => {
    const [orderId, setOrderId] = useState('');
    const [log, setLog] = useState('');
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [copy, setCopy] = useState(false);

    const { fetchLogs, logs, loading, initMessage } = useOrderShopperLogs(firebase, orderId);
    const fontSize = 14;

    const fieldsNotification = ['id', 'date', 'email', 'notificationType', 'orderId', 'message'];
    const fieldsAction = ['eventType', 'screen', 'productName', 'brandName', 'date', 'version', 'os', 'evidence'];
    const fieldsRequest = ['date', 'method', 'endpoint', 'response'];

    const getNameIcon = (type) => {
        if (type === 'notification') {
            return 'mail';
        }

        if (type === 'action') {
            return 'touch-app';
        }

        return 'http';
    };

    const getNameDrawer = () => {
        if (get(log, 'typeLog') === 'notification') {
            return 'notificación';
        }

        if (get(log, 'typeLog') === 'action') {
            return 'action';
        }

        return get(log, 'type');
    };

    const getColorIcon = (type) => {
        if (type === 'notification') {
            return 'rgb(52, 152, 219)';
        }

        if (type === 'action') {
            return ANDROID_GREEN;
        }

        return TIGERS_EYE;
    };

    const getFields = (type) => {
        if (type === 'notification') {
            return fieldsNotification;
        }

        if (type === 'action') {
            return fieldsAction;
        }

        return fieldsRequest;
    };

    const getColorMethod = (method) => {
        if (method === 'POST') {
            return 'rgb(52, 152, 219)';
        }

        if (method === 'GET') {
            return 'rgb(39, 174, 96)';
        }

        if (method === 'PUT') {
            return 'rgb(211, 84, 0)';
        }

        return GRANITE_GRAY;
    };

    const getColorInternalCode = (internalCode) => {
        if (internalCode === '200') {
            return 'rgb(39, 174, 96)';
        }

        return 'rgb(211, 84, 0)';
    };

    const getColorStatus = (status) => {
        if (status === 200) {
            return 'rgb(39, 174, 96)';
        }

        return 'rgb(211, 84, 0)';
    };

    const toggleDrawer = () => {
        setDrawerOpened(!drawerOpened);
    };

    const copyClipboard = (json, isUrl) => {
        setCopy(true);
        const jsonString = JSON.stringify(json, null, 2);
        const textarea = document.createElement('textarea');
        textarea.value = isUrl ? jsonString.slice(1, -1) : jsonString;

        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);

        setTimeout(() => {
            setCopy(false);
        }, 2000);

        notification.open({
            message: (<Row align='center' gap={5}>
                <Icon name='checkmark-circle' size={24} color='#22A889' />
                <Text text='copiado al portapapeles' size={12} />
            </Row>),
            style: { ...styleNotification, backgroundColor: '#E6F5F1', borderColor: '#B6DFD6' }
        });
    };

    const renderField = (field) => {
        return <Row gap={10}>
            <Text text={`${capitalize(field)}: `} strong size={15} />
            {field === 'evidence' || field === 'response'
                ? <Column padding={20} gap={10} style={{
                    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px'
                }}>
                    {!isEmpty(get(log, field)) &&
                    <Button
                        text='Copy'
                        style={{ width: 100 }}
                        onClick={() => copyClipboard(JSON.parse(get(log, field, '{}')))}
                    />}
                    <ReactJson src={JSON.parse(get(log, field, '{}'))} enableClipboard={false} />
                </Column>
                : <Text text={get(log, field)} size={15} />
            }
        </Row>;
    };

    return (
        <Main background='f4f4f4' withFooter>
            <FlexContainer paddingHorizontal={23} paddingVertical={16}>
                <Row border='1px solid #eaeaea' borderRadius={3} padding='3px 13px' backgroundColor={WHITE}>
                    <Row gap={10}>
                        <FormInput
                            label='Orden'
                            placeholder='Ingrese número de orden'
                            onChange={value => setOrderId(get(value, 'target.value'))}
                        />
                    </Row>
                    <FlexContainer justify='start' align='end' flex={3} mB={10}>
                        <Button text='Buscar' width={112} left={10} onClick={() => fetchLogs()} />
                    </FlexContainer>
                </Row>
            </FlexContainer>
            <Loading loading={loading}>
                <If
                    condition={!loading && !isEmpty(logs)}
                    then={<FlexContainer paddingHorizontal={23}>
                        <Row backgroundColor={WHITE} paddingHorizontal={20} paddingVertical={40}>
                            <Timeline>
                                {map(logs, ({ typeLog, message, date, notificationType, method, screen, eventType, evidence, endpoint, response, email, internalCode, status }, index) => {
                                    if (typeLog === 'notification' && isEmpty(message)) return null;

                                    return <Row>
                                        <Text text={moment(date).format('DD MMM, HH:mm:ss')} color='rgba(0, 0, 0, 0.54)' size={15} style={{ flex: '0 0 10%', minWidth: 150, textAlign: 'right', fontWeight: 600, marginTop: -5 }} />
                                        <Timeline.Item dot={<Row
                                            width={36}
                                            height={36}
                                            center
                                            backgroundColor={getColorIcon(typeLog)}
                                            boxShadow='0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'
                                            style={{ borderRadius: '50%' }}
                                        >
                                            <Icon name={getNameIcon(typeLog)} size={25} color={WHITE} style={{ marginTop: 4, marginLeft: 1 }} onClick={() => {
                                                toggleDrawer();
                                                setLog(logs[index]);
                                            }} pointer />
                                        </Row>}>
                                            <Column
                                                padding={10}
                                                mL={20}
                                                style={{
                                                    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px'
                                                }}>
                                                {typeLog === 'notification' && <>
                                                    <Row gap={3}>
                                                        <Text text='Message:' strong size={fontSize} />
                                                        <Text text={message} size={fontSize} />
                                                    </Row>
                                                    <Row gap={3}>
                                                        <Text text='NotificationType:' strong size={fontSize} />
                                                        <Text text={notificationType} size={fontSize} />
                                                    </Row>
                                                    <Row gap={3}>
                                                        <Text text='Email: ' strong size={fontSize} />
                                                        <Text text={email} size={fontSize} />
                                                    </Row>
                                                </>}
                                                {typeLog === 'action' && <>
                                                    <Row gap={3}>
                                                        <Text text='screen:' strong size={fontSize} />
                                                        <Text text={screen} size={fontSize} />
                                                    </Row>
                                                    <Row gap={3}>
                                                        <Text text='EventType:' strong size={fontSize} />
                                                        <Text text={eventType} size={fontSize} />
                                                    </Row>
                                                    <Row gap={3} onClick={() => copyClipboard(JSON.parse(evidence))} pointer style={{ cursor: copy ? 'default' : 'copy' }}>
                                                        <Text text='Evidence: ' strong size={fontSize} />
                                                        <pre className='pre-json'>
                                                            <code>
                                                                {JSON.stringify(JSON.parse(evidence), null, 2)}
                                                            </code>
                                                        </pre>
                                                    </Row>
                                                </>}
                                                {typeLog === 'logs' && <Column>
                                                    <Row gap={3} align='center' onClick={() => copyClipboard(endpoint, true)} pointer style={{ cursor: copy ? 'default' : 'copy' }}>
                                                        <Text text={method} color={getColorMethod(method)} size={16} strong />
                                                        <Text text={endpoint} size={fontSize} />
                                                    </Row>
                                                    {!isEmpty(internalCode) && <Row gap={3} align='center'>
                                                        <Text text={'InternalCode:'} strong size={fontSize} />
                                                        <Text text={internalCode} color={getColorInternalCode(internalCode)} strong size={fontSize} />
                                                        <Text text={' - '} strong />
                                                        <Text text={'Status:'} strong size={fontSize} />
                                                        <Text text={status} color={getColorStatus(status)} strong size={fontSize} />
                                                    </Row>}
                                                    {!isEmpty(response) && <Row gap={3} onClick={() => copyClipboard(JSON.parse(response))} pointer style={{ cursor: copy ? 'default' : 'copy' }}>
                                                        <Text text='Response:' strong size={fontSize} />
                                                        <pre className='pre-json'>
                                                            <code>
                                                                {JSON.stringify(JSON.parse(response), null, 2)}
                                                            </code>
                                                        </pre>
                                                    </Row>}
                                                </Column>}
                                            </Column>
                                        </Timeline.Item>
                                    </Row>;
                                })}
                            </Timeline>
                        </Row>
                    </FlexContainer>}
                    else={(
                        <NotFound
                            firstTextLine={initMessage}
                            icon='find'
                            backgroundColor='#F4F4F4'
                            iconBackgroundColor='#F4F4F4'
                            iconColor='#c0c0c0'
                            iconSize={85}
                            fontSize={20}
                            centered
                        />
                    )}
                />
            </Loading>
            <Drawer
                values={['80%', '70%', '100%']}
                title={<Row style={{ borderBottom: '4px solid #a4c735' }} justify='center' padding={10} backgroundColor='white'>
                    <Text text={capitalize(getNameDrawer())} size={15} strong />
                </Row>}
                closable
                visible={drawerOpened}
                onClose={toggleDrawer}>
                <Column gap={5}>
                    {map(getFields(get(log, 'typeLog')), renderField)}
                </Column>
            </Drawer>
        </Main>
    );
};

ShopperAppLogs.propTypes = {
    firebase: object
};

export default withFirebase(ShopperAppLogs);
